<template>
  <div class="layout-footer text-center">
    <img
      src="assets/layout/images/horizontal_extendido.png"
      alt="grsm horizontal extendido"
      width="300"
    />
  </div>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped></style>
